import { Layout } from '@/components/Layout/Layout';
import ClientSearchPage from 'components/PageLevelComponents/ClientSearchPage';
import { ANONYMOUS_TOKEN_NAME, LOCALE_DEFAULT } from 'config/config';
import type { GetServerSideProps } from 'next';
import { SearchPageController } from 'server/controller/page/search/searchPageController';
import type { ISearchPageResource } from 'server/resource/page/searchPageResource';

const RootPage = (props: ISearchPageResource) => {
  const {
    metaData,
    recipeEnv,
    searchItemLabels,
    searchPageLabels,
    footerNavData,
    footerImage,
    locale,
    searchOverlayData,
    countrySelectorData,
    newsletterData,
    contactUsUrl,
    difficultyCopy,
    getHeaderNav,
    getMobileNavData,
    popularSearchData,
    cardCarouselCMSData,
    recallData,
    pathTranslations,
    userToken,
    globalDictionary,
  } = props;
  return (
    <Layout
      themeName={undefined}
      pathTranslations={pathTranslations}
      locale={locale}
      globalMetadata={metaData}
      getHeaderNav={getHeaderNav}
      getMobileNavData={getMobileNavData}
      popularSearchData={popularSearchData}
      footerNavData={footerNavData}
      footerImage={footerImage}
      searchOverlayData={searchOverlayData}
      countrySelectorData={countrySelectorData}
      newsletterData={newsletterData}
      contactUsUrl={contactUsUrl}
      difficultyCopy={difficultyCopy as Record<string, string>}
      cardCarouselCMSData={cardCarouselCMSData}
      recallData={recallData}
      userToken={userToken}
      globalDictionary={globalDictionary}
    >
      <ClientSearchPage
        recipeEnv={recipeEnv}
        locale={locale}
        searchItemLabels={searchItemLabels as Record<string, string>}
        searchPageLabels={searchPageLabels}
      />
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  defaultLocale,
  resolvedUrl,
  req,
}) => {
  const anonymousToken = req.cookies[ANONYMOUS_TOKEN_NAME];
  return SearchPageController.getCachedSearchPageData({
    resolvedUrl,
    locale: locale || defaultLocale || LOCALE_DEFAULT,
    userToken: anonymousToken ?? '',
  });
};

export default RootPage;
